import PageDetail from "../abstract/PageDetail.js";
import { SecurityAcl, AuthCheckAcl } from "../../Security.js";
import GridWrapper from "../../su/GridWrapper.js";
import AgGridWrapper from "../../su/AgGridWrapper.js";

export default class PageDashboard extends PageDetail {
    constructor() {
        super();
    }

    init($data) {
        super.init($data);

        this.initSpecialRequestsList();

        this.initAgListLastEdit();
    }

    initListButton(ev) {
        if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_READ))) {
            $(".btnView", ev.mcCol).on("click", this.onNavigate.bind(this, ev.dataIndex));
        } else {
            $(".btnView", ev.mcCol).remove();
        }
    }

    initSpecialRequestsList() {
        // h
        let h = this.getAvailableHeight();
        //
        this.theGrid = new GridWrapper($(".jsList"));

        let options = {
            dataSource: {
                // data: $data.rows,
            },
            sorting: {
                multiple: false,
                allowUnsort: false
            },
            paging: {
                pageSize: 24,
                pageLinksCount: 10
            },
            rowHover: false,
            altRows: false,
            columns: [
                {
                    field: "PeriodTypeLabel",
                    title: "Periodo"
                },
                {
                    field: "Type",
                    title: "Tipo"
                },
                {
                    field: "UidLookupSpecialrequestStatusLabel",
                    title: "Stato"
                },
                {
                    field: "Total",
                    title: "Totali"
                },
                {
                    field: "PercentageValue",
                    title: "%"
                },
                {
                    field: "AverageValue",
                    title: "Media Giorni"
                }
                    
            ],
            scrolling: true,
            resizing: true,
            height: h + "px"
        }

        this.theGrid.create(options, this.data.rows);
        this.theGrid.enableSearch($(".jsListSearch"), {
            or: [
                { path: "PeriodTypeLabel", filter: "contains", value: "" },
                { path: "Type", filter: "contains", value: "" },
                { path: "UidLookupSpecialrequestStatusLabel", filter: "contains", value: "" },
             
            ]
        });
        this.theGrid.init("jsList1");
        // var a = StateManager.getViewState("jsList")
        jQuery(window).on("resize.grid", this.onResize.bind(this));

        return;
    }
    

    getAvailableHeight() {
        let a = jQuery(".js-size");
        let i = 0;
        for (let x = 0; x < a.length; x++) {
            i += jQuery(a[x]).outerHeight();
        }
        i += 50; // padding app container
        i += 78; // search box
        i += 143; // paging
        let h = jQuery(window).height() - i;
        return h;
    }

    onResize(e) {
        //debugger;
        this.theGrid.setHeight(this.getAvailableHeight());
    }

    initAgListLastEdit() {
        const rowData = [];
        for (let x = 0; x < this.data.lastEditsRows.length; x++) {
            const row = this.data.lastEditsRows[x];
            rowData.push(row);
        }
        this.rowData = rowData;

        const searchBox = document.getElementById("filter-text-box-lastedit");

        const targetGrid = document.querySelector(".js-aglist-lastedit");
        const h = this.getAvailableHeight();
        targetGrid.style.height = h + "px";

        const columnDefs = [
            {
                field: "EntityType",
                headerName: "Tipo",
            },
            {
                field: "EntityLabel",
                headerName: "Descrizione"
            },
            {
                field: "LastEditedBy",
                headerName: "Modificato da"
            },
            {
                field: "LastEditedDate",
                headerName: "Data modifica",
                type: AgGridWrapper.TYPE_DATE_LOCAL_STRING,
            },
        ];

        // Inizializzazione della griglia (Copia incolla tranne il primo parametro che è un id arbitrario ma usiamo generalmente il nome della pagina)
        let agGrid = new AgGridWrapper("PageDashboardLastEditList", AgGridWrapper.MODE_SIMPLE);
        const options = agGrid.getConfig({
            paginationPageSize: 20,
            onRowClicked: this.onRowClicked.bind(this),
            customOptions: {
                doNotshowSelection: true, // In modo casereccio non mostra la selezione
                removeOldList: false, // Rimuove la vecchia griglia dalla pagina (punta sul fatto che i nodi che la contengono si chiamino "jsList" e "filterbox" grazie al solito copia-incolla selvaggio).
            },
            columnDefs,
            rowData,
        });

        // Crea la griglia e ascolta il resize della finestra per cambiare l'altezza
        agGrid.init(targetGrid, searchBox, options);
        window.onresize = this.arrangeGrid.bind(this, agGrid);
    }

    arrangeGrid(agGrid) {
        // Punta alla griglia e ne imposta l'altezza
        const h = this.getAvailableHeight();
        agGrid.targetGrid.style.height = h + "px";
    }

    onRowClicked(params) {
        try {
            let item = params.data;
            if (item.EntityType === 'NEWS') {
                document.location.href = TheApp.Env.BaseUrlNls + "news/detail/" + Base64.toBase64(item.EntityUid, true);
            }
            else if (item.EntityType === 'FAQ') {
                document.location.href = TheApp.Env.BaseUrlNls + "faq/detail/" + Base64.toBase64(item.EntityUid, true);
            } else if (item.EntityType === 'DOCUMENT') {
                document.location.href = TheApp.Env.BaseUrlNls + "documents/detail/" + Base64.toBase64(item.EntityUid, true);
            } else if (item.EntityType === 'PRIVACY') {
                document.location.href = TheApp.Env.BaseUrlNls + "privacy/detail/" + Base64.toBase64(item.EntityUid, true);
            } else if (item.EntityType === 'SPECIALREQUEST') {
                document.location.href = TheApp.Env.BaseUrlNls + "specialrequest/detail/" + Base64.toBase64(item.EntityUid, true);
            } else if (item.EntityType === 'MEDIA') {
                document.location.href = TheApp.Env.BaseUrlNls + "media/detail/" + Base64.toBase64(item.EntityUid, true);
            }
        }
        catch (ex) {
        }
    }
    // FINE COPIA INCOLLA
}

